<template>
  <v-container nowrap grid-list-md class="pa-0">
    <v-layout>
      <v-flex xs12>
        <span class="font-weight-bold">Unidades Consumidoras</span>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="filteredQualifications"
      hide-actions
      no-data-text="Nenhuma Qualificação Encontrada"
    >
      <template v-slot:items="props">
        <td :class="props.item.status | formatQualificationStatusColor">
          {{ props.item.consumer_unit }}
        </td>
        <td :class="props.item.status | formatQualificationStatusColor">
          {{ props.item.utility_company || "cemig" }}
        </td>
        <td :class="props.item.status | formatQualificationStatusColor">
          {{ address(props.item) }}
        </td>
        <td :class="props.item.status | formatQualificationStatusColor">
          {{
            props.item.status == "error" &&
            props.item?.process_status == "error_debts"
              ? props.item.process_status
              : props.item.status | formatUCStatus
          }}
        </td>

        <td
          align="center"
          class="mx-auto"
          :class="props.item.status | formatQualificationStatusColor"
        >
          <v-icon
            class="mx-auto"
            small
            @click="deleteItem(props.item)"
            v-if="canErase(props.item.status)"
          >
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="showCancellationDialog" persistent max-width="500">
      <v-card class="pa-3">
        <v-card-title class="pa-0 pt-2">
          <span class="title font-weight-bold mx-auto"
            >Deseja remover essa qualificação?</span
          >
        </v-card-title>
        <v-card-text class="pt-2 pb-3">
          <div xs12 md12 class="dialog-container mx-4">
            <p class="">
              Essa qualificação não será considerada no momento da venda.
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" text @click="closeCancellationDialog"
              >Fechar</v-btn
            >
            <v-btn color="pink darken-1" text @click="confirmCancellation"
              >Confirmar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import statesfile from "@/model/state";

export default {
  name: "QualificationList",

  data: () => ({
    headers: [
      {
        text: "Numero de Instalação",
        align: "left",
        value: "id",
      },
      { text: "Concessionária", value: "utility_company" },
      { text: "Endereço", value: "address" },
      { text: "Status", value: "status" },
      { text: "Ações", value: "", align: "center", sortable: false },
    ],
    qualification: null,
    states: statesfile.estados,
    newQualifications: null,
    showCancellationDialog: false,
  }),

  computed: {
    ...mapState("qualification", ["qualifications"]),

    qualification_ids() {
      return this.qualifications.map((qual) => qual.id) ?? [];
    },

    filteredQualifications() {
      return [...new Set(this.qualifications)];
    },
  },

  methods: {
    ...mapMutations("qualification", ["setQualifications"]),

    deleteItem(item) {
      this.showCancellationDialog = true;
      const qualifications = this.qualifications.map((el) => el);
      this.newQualifications = qualifications.filter((i) => i.id !== item.id);
    },

    closeCancellationDialog() {
      this.showCancellationDialog = false;
      this.newQualifications;
    },

    confirmCancellation() {
      this.setQualifications(this.newQualifications);
      this.closeCancellationDialog();
    },

    address(qualification) {
      if (qualification?.consumer_unit_detail?.address) {
        const address = qualification?.consumer_unit_detail?.address;
        let _address = address.address;
        _address =
          _address +
          (address.address_number ? ", " + address?.address_number : "");
        _address =
          _address + (address.complement ? ", " + address?.complement : "");
        _address =
          _address + (address.district ? ", " + address?.district : "");
        _address = _address + (address.city ? ", " + address.city : "");
        _address =
          _address +
          (address.state?.initials ? " - " + address?.state?.initials : "");
        _address =
          _address +
          (address.postal_code ? " - CEP: " + address?.postal_code : "");
        return _address;
      } else return qualification.address;
    },

    canErase(status) {
      return (
        status === "error" ||
        status === "bill_not_found" ||
        status === "disqualified" ||
        status === "pending" ||
        status === "qualified"
      );
    },
  },
};
</script>
